"use client";

import {
  WorkplaceRequestCategory,
  WorkplaceRequestTypeElement
} from "@gettactic/api";
import React from "react";
import { InfoBlockCard } from "@/features/workplace-requests/components/InfoBlockCard";
import { RequestTypeHeader } from "./RequestTypeHeader";

interface RequestInstructionsStepProps {
  type: WorkplaceRequestTypeElement;
  category?: WorkplaceRequestCategory;
  onChangeType?: () => void;
}

/**
 * Step 2 for a link request type: the admin's instructions, and nowhere to go
 * from here.
 *
 * There is no Submit and no confirmation — the flow dead-ends on purpose, and
 * the action is a link inside the copy. The wizard supplies the heading and the
 * warning subhead from the step itself; this only renders what the type carries.
 */
export const RequestInstructionsStep: React.FC<
  RequestInstructionsStepProps
> = ({ type, category, onChangeType }) => (
  <div className="flex flex-col gap-5">
    <RequestTypeHeader
      type={type}
      category={category}
      onChangeType={onChangeType}
    />
    <InfoBlockCard html={type.instructions} />
  </div>
);
